import * as React from "react";
import { styled } from "@mui/material";
import { MessageTemplate } from "@kahunmedical/common-configuration/dist/configuration/messageTemplate";
import { getMetadataContainerForClass } from "@kahunmedical/common-configuration/dist/lib/annotations";
import { KahunSettingPresentation } from "../kahunSettingPresentation";
import { useMemo } from "react";
import { ConfigMetaData } from "@kahunmedical/common-configuration";

//region [[ Styles ]]

const MessageTemplateEditorView = styled("div")({
  width: "100%",
  border: "1px solid #232323",
  padding: "5px",
  borderRadius: "15px",
  margin: "15px",
  "& .kahun-setting-presentation-view, & .kahun-setting-presentation-view:nth-of-type(2n+1)": {
    padding: 0,
    border: "none",
    flexWrap: "wrap",
    margin: 5,
    "& > *": {
      flex: 1,
    },
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface MessageTemplateEditorProps {
  value: MessageTemplate;
  onChange: (newValue: MessageTemplate) => void;
  source: string;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
const toValueWithSource = (value: any, source: string) => {
  if (Object.keys(value).some((k) => k === "source")) return value;
  return { value, source };
};
//endregion [[ Functions ]]

const MetaData = getMetadataContainerForClass(MessageTemplate);
// console.log("MetaData", MetaData);
export const MessageTemplateEditor = ({
  value,
  source,
  ...props
}: MessageTemplateEditorProps) => {
  const handleValueChanged = (key, newValue) => {
    props.onChange({
      ...(value || {}),
      [key]: newValue,
    } as MessageTemplate);
  };

  const eachKeyValueWithSource = useMemo(() => {
    // console.log("new value in MessageTemplateEditor", value);
    return Object.entries(value || {}).reduce(
      (acc, [k, v]) => ({ ...acc, [k]: toValueWithSource(v, source) }),
      {},
    );
  }, [value, source]);

  return (
    <MessageTemplateEditorView>
      {MetaData.map((key) => (
        <KahunSettingPresentation
          key={key.key}
          setting={key as ConfigMetaData}
          onValueChanged={handleValueChanged}
          valueWithSource={eachKeyValueWithSource[key.key]}
          onSubObjectExpand={() => {}}
          disabled={props.disabled}
        />
      ))}
    </MessageTemplateEditorView>
  );
};
